import { promise } from '../../../helpers';
import { updateLearningCommunityGroup } from './index';

const updateLearningCommunityGroups = props => {
    const { where } = props;

    if (where) {
        return updateLearningCommunityGroup(props);
    }

    return promise();
};

export default updateLearningCommunityGroups;
